const t = "p";
export {
  t as cardSubtitleDefaultAs
};
